import {ConstraintType, ISolution, getTimezoneOffset} from '@mobi-components/global-solution';
import {RecommendationContext} from '../state/global.types';
import {SolutionResponse} from '../solution/solution-support.types';
import {generateActivityForPoi} from './submit-amex-problem';
import {APIService} from '@/services/api.service';
import {LunchTime} from './reschedule-activity';

export async function submitAmexAdditionalActivitiesProblem(
  sessionId: string,
  solution: ISolution,
  additionalItems: RecommendationContext[],
  knownActivities: RecommendationContext[],
  mealPrefference: LunchTime = LunchTime.NONE,
): Promise<SolutionResponse> {
  const additionalActivities = additionalItems.map((x: RecommendationContext) => {
    const isItKnown = knownActivities.findIndex((y) => y.id === x.originalId || y.name === x.name) >= 0;
    const isItActivitiyItem = solution.activities.find((y) => y.id === x.originalId);

    const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const myTzOffsetMins = new Date().getTimezoneOffset();
    const timezoneOffsetMins = Math.round(getTimezoneOffset(new Date(), x.timezone || localTimeZone)) - myTzOffsetMins;
    const z = {
      ...x,
      id: x.originalId || x.id,
    };
    
    z.scheduled_start_time = x.start_timestamp + timezoneOffsetMins * 60 * 1000;
    z.scheduled_end_time = x.end_timestamp + timezoneOffsetMins * 60 * 1000;

    const candidateName = z.name
      .replace('LUNCH:', '')
      .replace('BREAKFAST:', '')
      .replace('DINNER:', '')
      .trim();

    const poi = generateActivityForPoi(
      z.id,
      isItKnown || isItActivitiyItem ? null : z.name,
      candidateName,
      z.scheduled_start_time,
      z.scheduled_end_time,
    );
    poi.start_constraint_type = ConstraintType.NOT_EARLIER_THAN;
    poi.end_constraint_type = ConstraintType.NOT_LATER_THAN;
    return poi;
  });

  const activity_keyword = (mealPrefference || '').toUpperCase();

  return APIService.post<SolutionResponse>(`problem/new-activities`, additionalActivities, {
    params: {
      session_id: sessionId,
      activity_keyword,
    },
  });
}
